import { Component, OnInit } from '@angular/core';
import {Master} from '../../../admin/models/master.interface';
import {QuestionsService} from '../../services/questions.service';
import {QuestionsSearch} from '../../models/questions-search.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {Questions} from '../../models/questions.interface';
import {Page} from '../../../shared/models/page.interface';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  questions!: Page<Questions>;
  categories!: Master[];
  search!: QuestionsSearch;
  private page: PageRequest = {page: 0, size: 100, sort: 'shortCode', direction: 'asc'};
  constructor(private readonly questionsService: QuestionsService,
              private messageService: MessageService,
              private readonly router: Router) { }

  ngOnInit(): void {
    this.questionsService.getAllQuestionCategories('', {page: 0, size: 100, sort: '', direction: 'asc'}).subscribe(
      data => this.categories = data.content
    );
    this.questionsService.getAllQuestions({status: 'ACTIVE'}, this.page).subscribe(
      data => this.questions = data
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadQuestions(event: PageRequest): void {
    this.page = event;
    this.updateData();
  }

  searchQuestions(search: QuestionsSearch): void {
    this.search = search;
    if (Object.keys(search).length === 0) {
      this.page = {page: 0, size: 100, sort: 'shortCode', direction: 'asc'};
    }
    this.questionsService.getAllQuestions(search, this.page).subscribe(
      data => this.questions = data
    );
  }

  updateQuestionStatus(id: number): void {
    this.questionsService.updateQuestion(id).subscribe(
      () => this.updateData()
    );
  }

  private updateData(): void {
    if (this.search) {
      this.questionsService.getAllQuestions(this.search, this.page).subscribe(
        data => this.questions = data
      );
    }
    else {
      this.questionsService.getAllQuestions({status: 'ACTIVE'}, this.page).subscribe(
        data => this.questions = data
      );
    }
  }

}
